<template>
  <div class="index">
    <Back />
    <div class="function">
      <Quwei v-if="id === 0"></Quwei>
      <Peitao v-if="id === 1"></Peitao>
      <Gaikuang v-if="id === 2"></Gaikuang>
    </div>
  </div>
</template>

<script>
import Quwei from '../components/Quwei.vue'
import Peitao from '../components/Peitao.vue'
import Gaikuang from '../components/Gaikuang.vue'
import Back from '../components/back.vue'
export default {
  created() {
    this.id = this.$route.query.id
  },
  components: {
    Quwei,
    Peitao,
    Gaikuang,
    Back
  }
}
</script>

<style lang="scss" scoped>
.index {
  width: 100%;
  height: 100%;
  text-align: center;
  overflow: hidden;
  margin-top: 265px;
  .function {
    width: 320px;
    padding: 10px;
    border-radius: 8px;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
    background: #fff;
    margin: auto;
  }
}
</style>
